import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Page from '../components/Page';
import DefaultContainer from '../components/DefaultContainer';
import TitleDescription from '../components/TitleDescription';
import Image from '../components/Image';
import DefaultTextField from '../components/DefaultTextField';
import FormSubmitButton from '../components/FormSubmitButton';
import HeadlineLarge from '../components/HeadlineLarge';
import t from '../data/startups/startupVentures';
import variables from '../styles/variables.module.scss';
import {
  FormControlLabel,
  Checkbox as MuiCheckbox,
  withStyles,
} from '@material-ui/core';
import { Link } from 'gatsby';

const maxCharacters = 500;

const StartupPage = () => {
  const [values, setValues] = useState({
    name: '',
    email: '',
    website: '',
    mobile: '',
    city: '',
    teamName: '',
    ideaDesc: '',
    targetCustomerAndProblem: '',
    evidenceOfDemand: '',
    aboutTeam: '',
    businessModel: '',
    competitors: '',
    firstMilestone: '',
    scalabilityAndMarketPotential: '',
    competitorsDesc: '',
    sellTheIdea: '',
    termsAccepted: false,
  });

  const handleChange = type => event => {
    setValues({ ...values, [type]: event.target.value });
  };

  const handleTextAreaChange = event => {
    const { name, value } = event.target;
    if (event.target.value.length <= maxCharacters) {
      setValues({ ...values, [name]: value });
    }
  };

  const handleCheckboxChange = event => {
    const { name, checked } = event.target;
    setValues({ ...values, [name]: checked });
  };

  const Checkbox = withStyles({
    root: {
      color: variables.springGreen,
    },
  })(props => <MuiCheckbox color="default" {...props} />);

  return (
    <Page
      offset
      style={{
        backgroundColor: variables.carbonBlack,
      }}
    >
      <DefaultContainer
        direction="column"
        style={{ marginBottom: 40, marginTop: 150 }}
        maxWidth="md"
      >
        <Grid
          xs={12}
          item
          style={{
            marginBottom: 80,
            alignSelf: 'flex-end',
            textAlign: 'right',
          }}
        >
          <HeadlineLarge lineBreak stroke="Ventures">
            Startup
          </HeadlineLarge>
        </Grid>
        <Grid xs={12} item style={{ marginBottom: 30 }}>
          <TitleDescription
            title={t.title1}
            description={t.desc1}
          />
        </Grid>
        <Grid xs={12} item style={{ marginBottom: 30 }}>
          <TitleDescription
            title={t.title2}
            description={t.desc2}
          />
        </Grid>
        <Grid xs={12} item style={{ marginBottom: 30 }}>
          <TitleDescription
            title={t.title3}
            description={t.desc3}
          />
        </Grid>
      </DefaultContainer>
      <Image source={t.banner} style={{ width: '100%' }} />
      <form
        name="startup-ventures"
        method="POST"
        data-netlify="true"
        netlify-honeypot="bot-field"
      >
        <input
          type="hidden"
          name="form-name"
          value="startup-ventures"
        />
        <input type="hidden" name="bot-field" />
        <DefaultContainer
          spacing={5}
          style={{ padding: '50px 0 100px' }}
          maxWidth="md"
        >
          <Grid xs={12} item style={{ marginBottom: 50 }}>
            <TitleDescription title={t.title7}>
              {t.desc7}
            </TitleDescription>
          </Grid>
          <Grid item xs={12} sm={6}>
            <DefaultTextField
              id="name"
              name="name"
              label={t.labelName}
              value={values.name}
              onChange={handleChange('name')}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <DefaultTextField
              type="email"
              id="email"
              name="email"
              label={t.labelEmail}
              value={values.email}
              onChange={handleChange('email')}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <DefaultTextField
              id="website"
              name="website"
              label={t.labelWebsite}
              value={values.website}
              onChange={handleChange('website')}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <DefaultTextField
              type="tel"
              id="mobile"
              name="mobile"
              label={t.labelMobile}
              value={values.mobile}
              onChange={handleChange('mobile')}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <DefaultTextField
              id="city"
              name="city"
              label={t.labelCity}
              value={values.city}
              onChange={handleChange('city')}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <DefaultTextField
              id="teamName"
              name="teamName"
              label="Name of your team/idea"
              value={values.teamName}
              onChange={handleChange('teamName')}
              fullWidth
              required
            />
          </Grid>
          <Grid xs={12} item style={{ marginTop: 30 }}>
            <TitleDescription
              title={t.title5}
              description={t.desc5}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <DefaultTextField
              id="ideaDesc"
              name="ideaDesc"
              placeholder={t.placeholderIdeaDesc}
              multiline
              rows={10}
              helperText={`${values.ideaDesc.length}/${maxCharacters}`}
              value={values.ideaDesc}
              onChange={handleTextAreaChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <DefaultTextField
              id="targetCustomerAndProblem"
              name="targetCustomerAndProblem"
              placeholder={
                t.placeholderTargetCustomerAndProblem
              }
              multiline
              rows={10}
              helperText={`${values.targetCustomerAndProblem.length}/${maxCharacters}`}
              value={values.targetCustomerAndProblem}
              onChange={handleTextAreaChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <DefaultTextField
              id="evidenceOfDemand"
              name="evidenceOfDemand"
              placeholder={t.placeholderEvidenceOfDemand}
              multiline
              rows={10}
              helperText={`${values.evidenceOfDemand.length}/${maxCharacters}`}
              value={values.evidenceOfDemand}
              onChange={handleTextAreaChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <DefaultTextField
              id="aboutTeam"
              name="aboutTeam"
              placeholder={t.placeholderAboutTeam}
              multiline
              rows={10}
              helperText={`${values.aboutTeam.length}/${maxCharacters}`}
              value={values.aboutTeam}
              onChange={handleTextAreaChange}
              fullWidth
              required
            />
          </Grid>
          <Grid
            item
            xs={12}
            style={{ marginTop: 40, marginBottom: 30 }}
          >
            <TitleDescription
              title={t.title6}
              description={t.desc6}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <DefaultTextField
              id="businessModel"
              name="businessModel"
              placeholder={t.placeholderBusinessModel}
              multiline
              rows={10}
              helperText={`${values.businessModel.length}/${maxCharacters}`}
              value={values.businessModel}
              onChange={handleTextAreaChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <DefaultTextField
              id="competitors"
              name="competitors"
              placeholder={t.placeholderCompetitors}
              multiline
              rows={10}
              helperText={`${values.competitors.length}/${maxCharacters}`}
              value={values.competitors}
              onChange={handleTextAreaChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <DefaultTextField
              id="firstMilestone"
              name="firstMilestone"
              placeholder={t.placeholderFirstMilestone}
              multiline
              rows={10}
              helperText={`${values.firstMilestone.length}/${maxCharacters}`}
              value={values.firstMilestone}
              onChange={handleTextAreaChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <DefaultTextField
              id="scalabilityAndMarketPotential"
              name="scalabilityAndMarketPotential"
              placeholder={
                t.placeholderScalabilityAndMarketPotential
              }
              multiline
              rows={10}
              helperText={`${values.scalabilityAndMarketPotential.length}/${maxCharacters}`}
              value={values.scalabilityAndMarketPotential}
              onChange={handleTextAreaChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <DefaultTextField
              id="sellTheIdea"
              name="sellTheIdea"
              placeholder={t.placeholderSellTheIdea}
              multiline
              rows={10}
              helperText={`${values.sellTheIdea.length}/${maxCharacters}`}
              value={values.sellTheIdea}
              onChange={handleTextAreaChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} style={{ margin: '40px 0' }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={values.termsAccepted}
                  onChange={handleCheckboxChange}
                  name="termsAccepted"
                />
              }
              label={
                <p>
                  I agree to the{' '}
                  <a href="/cookie-policy" target="__blank">
                    <span
                      style={{
                        color: variables.springGreen,
                        textDecoration: 'underline',
                        textDecorationColor:
                          variables.springGreen,
                      }}
                    >
                      terms and conditions
                    </span>
                  </a>
                </p>
              }
              color="primary"
            />
            <FormSubmitButton
              disabled={!values.termsAccepted}
            >
              Submit
            </FormSubmitButton>
          </Grid>
          <Grid item>
            <h4>{t.footerText}</h4>
          </Grid>
        </DefaultContainer>
      </form>
    </Page>
  );
};

export default StartupPage;

// CLOSED COMPETITION PAGE
/* <Page
      offset
      style={{
        backgroundColor: variables.carbonBlack,
      }}
    >
      <DefaultContainer
        direction="column"
        style={{ marginBottom: 40, marginTop: 150 }}
        maxWidth="md"
      >
        <Grid
          xs={12}
          item
          style={{
            marginBottom: 80,
            alignSelf: 'flex-end',
            textAlign: 'right',
          }}
        >
          <HeadlineLarge lineBreak stroke="Competition">
            Startup
          </HeadlineLarge>
        </Grid>
        <Grid xs={12} item style={{ marginTop: 80 }}>
          <h3>
            The competition is now closed for applications.
            Best of luck to all participating teams. More
            information will follow shortly.
          </h3>
          <h4
            style={{
              textAlign: 'end',
              color: variables.springGreen,
              marginTop: 30,
              marginBottom: 100,
            }}
          >
            Best, We App team
          </h4>
        </Grid>
      </DefaultContainer>
    </Page> */
